module.exports = __webpack_public_path__ + "static/media/logo.20ba1c63.jpg";